// blogPostsSet14.js - Articulos 164+ (SEO 2026)

export const blogPostsSet14 = [
  {
    id: 164,
    slug: "alimentos-ricos-proteina-lista-completa",
    title: "50 Alimentos Ricos en Proteína: Lista Completa con Gramos por Ración (2026)",
    seoTitle: "Tabla de Alimentos Ricos en Proteína: 50 con Gramos (2026)",
    h1: "50 alimentos ricos en proteína (con gramos por ración)",
    excerpt: "Lista completa de alimentos altos en proteína por ración real: carnes, pescados, lácteos, legumbres, opciones vegetales y suplementos.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">Si estás intentando comer más proteína pero no sabes qué alimentos tienen más, esta lista te lo resuelve. Hemos ordenado 50 alimentos por gramos de proteína por ración habitual, no por 100g, sino por lo que realmente te comes de una vez.</p>

        <p>La respuesta rápida: los alimentos con más proteína por ración son la <strong>pechuga de pollo</strong> (46g en 150g), el <strong>pavo</strong> (44g en 150g), la <strong>ternera magra</strong> (39g en 150g) y el <strong>salmón</strong> (34g en 150g). Pero hay muchas opciones más allá de la carne que también aportan cantidades significativas.</p>

        <h2>Top 50 alimentos ricos en proteína</h2>

        <h3>Carnes y aves</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Pechuga de pollo</td><td>150g</td><td>46g</td><td>248 kcal</td></tr>
            <tr><td>Pechuga de pavo</td><td>150g</td><td>44g</td><td>210 kcal</td></tr>
            <tr><td>Ternera magra (solomillo)</td><td>150g</td><td>39g</td><td>225 kcal</td></tr>
            <tr><td>Cerdo lomo</td><td>150g</td><td>38g</td><td>232 kcal</td></tr>
            <tr><td>Conejo</td><td>150g</td><td>33g</td><td>220 kcal</td></tr>
            <tr><td>Jamón serrano</td><td>60g (4 lonchas)</td><td>20g</td><td>140 kcal</td></tr>
            <tr><td>Pavo en lonchas</td><td>80g</td><td>18g</td><td>88 kcal</td></tr>
            <tr><td>Jamón york</td><td>80g</td><td>14g</td><td>96 kcal</td></tr>
          </tbody>
        </table>

        <h3>Pescados y mariscos</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Atún fresco</td><td>150g</td><td>38g</td><td>220 kcal</td></tr>
            <tr><td>Salmón</td><td>150g</td><td>34g</td><td>312 kcal</td></tr>
            <tr><td>Bacalao</td><td>150g</td><td>30g</td><td>135 kcal</td></tr>
            <tr><td>Merluza</td><td>150g</td><td>27g</td><td>128 kcal</td></tr>
            <tr><td>Gambas/langostinos</td><td>150g</td><td>27g</td><td>135 kcal</td></tr>
            <tr><td>Atún en lata (al natural)</td><td>80g (1 lata)</td><td>24g</td><td>96 kcal</td></tr>
            <tr><td>Sardinas en lata</td><td>85g (1 lata)</td><td>21g</td><td>170 kcal</td></tr>
            <tr><td>Mejillones</td><td>150g</td><td>18g</td><td>128 kcal</td></tr>
            <tr><td>Sepia/calamar</td><td>150g</td><td>27g</td><td>120 kcal</td></tr>
          </tbody>
        </table>

        <h3>Huevos y lácteos</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Claras de huevo</td><td>4 claras (130g)</td><td>14g</td><td>68 kcal</td></tr>
            <tr><td>Huevos enteros</td><td>2 unidades</td><td>14g</td><td>156 kcal</td></tr>
            <tr><td>Yogur griego natural</td><td>200g</td><td>20g</td><td>130 kcal</td></tr>
            <tr><td>Queso cottage/requesón</td><td>200g</td><td>24g</td><td>196 kcal</td></tr>
            <tr><td>Queso fresco batido 0%</td><td>250g</td><td>20g</td><td>125 kcal</td></tr>
            <tr><td>Skyr</td><td>150g</td><td>16g</td><td>100 kcal</td></tr>
            <tr><td>Mozzarella fresca</td><td>100g</td><td>18g</td><td>250 kcal</td></tr>
            <tr><td>Leche desnatada</td><td>250ml</td><td>9g</td><td>88 kcal</td></tr>
            <tr><td>Queso curado</td><td>40g</td><td>12g</td><td>160 kcal</td></tr>
          </tbody>
        </table>

        <h3>Legumbres y cereales</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Lentejas cocidas</td><td>200g</td><td>18g</td><td>230 kcal</td></tr>
            <tr><td>Garbanzos cocidos</td><td>200g</td><td>16g</td><td>246 kcal</td></tr>
            <tr><td>Alubias/judías cocidas</td><td>200g</td><td>16g</td><td>240 kcal</td></tr>
            <tr><td>Edamame</td><td>150g</td><td>17g</td><td>188 kcal</td></tr>
            <tr><td>Quinoa cocida</td><td>200g</td><td>9g</td><td>240 kcal</td></tr>
            <tr><td>Avena</td><td>50g (en seco)</td><td>7g</td><td>190 kcal</td></tr>
            <tr><td>Pan integral</td><td>2 rebanadas (60g)</td><td>6g</td><td>140 kcal</td></tr>
          </tbody>
        </table>

        <h3>Proteínas vegetales</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Seitán</td><td>100g</td><td>25g</td><td>140 kcal</td></tr>
            <tr><td>Tofu firme</td><td>150g</td><td>18g</td><td>180 kcal</td></tr>
            <tr><td>Tempeh</td><td>100g</td><td>19g</td><td>195 kcal</td></tr>
            <tr><td>Soja texturizada (en seco)</td><td>50g</td><td>25g</td><td>170 kcal</td></tr>
            <tr><td>Cacahuetes</td><td>40g</td><td>10g</td><td>230 kcal</td></tr>
            <tr><td>Almendras</td><td>30g</td><td>6g</td><td>175 kcal</td></tr>
          </tbody>
        </table>

        <h3>Suplementos</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Ración</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Whey protein</td><td>1 scoop (30g)</td><td>24g</td><td>120 kcal</td></tr>
            <tr><td>Caseína</td><td>1 scoop (30g)</td><td>24g</td><td>120 kcal</td></tr>
            <tr><td>Proteína vegana (guisante+arroz)</td><td>1 scoop (35g)</td><td>20g</td><td>130 kcal</td></tr>
          </tbody>
        </table>

        <h2>Combinaciones para llegar a 150g de proteína al día</h2>

        <h3>Opción 1: Clásica (para omnívoros)</h3>
        <ul>
          <li><strong>Desayuno:</strong> 2 huevos + yogur griego = 34g</li>
          <li><strong>Almuerzo:</strong> pechuga de pollo (150g) = 46g</li>
          <li><strong>Merienda:</strong> atún en lata = 24g</li>
          <li><strong>Cena:</strong> salmón (150g) = 34g</li>
          <li><strong>Snack:</strong> cottage cheese (150g) = 18g</li>
        </ul>
        <p><strong>Total: 156g</strong></p>

        <h3>Opción 2: Económica</h3>
        <ul>
          <li><strong>Desayuno:</strong> avena + whey protein = 31g</li>
          <li><strong>Almuerzo:</strong> muslo de pollo (200g) + lentejas = 48g</li>
          <li><strong>Merienda:</strong> 3 huevos duros = 21g</li>
          <li><strong>Cena:</strong> atún en lata (2 latas) + ensalada = 48g</li>
          <li><strong>Snack:</strong> yogur griego = 20g</li>
        </ul>
        <p><strong>Total: 168g</strong></p>

        <h3>Opción 3: Vegetariana</h3>
        <ul>
          <li><strong>Desayuno:</strong> yogur griego + avena + proteína vegana = 40g</li>
          <li><strong>Almuerzo:</strong> lentejas (200g) + tofu (100g) + arroz = 30g</li>
          <li><strong>Merienda:</strong> edamame (150g) = 17g</li>
          <li><strong>Cena:</strong> seitán (100g) + garbanzos (150g) + verduras = 37g</li>
          <li><strong>Snack:</strong> cottage cheese (200g) = 24g</li>
        </ul>
        <p><strong>Total: 148g</strong></p>

        <h2>Alimentos con mejor ratio proteína/calorías</h2>
        <p>Si estás en déficit calórico y necesitas proteína alta con pocas calorías, estos son los mejores:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Proteína por 100 kcal</th></tr>
          </thead>
          <tbody>
            <tr><td>Claras de huevo</td><td>21g</td></tr>
            <tr><td>Pechuga de pavo</td><td>21g</td></tr>
            <tr><td>Bacalao</td><td>22g</td></tr>
            <tr><td>Atún en lata (natural)</td><td>25g</td></tr>
            <tr><td>Gambas</td><td>20g</td></tr>
            <tr><td>Pechuga de pollo</td><td>19g</td></tr>
            <tr><td>Merluza</td><td>21g</td></tr>
            <tr><td>Queso fresco batido 0%</td><td>16g</td></tr>
            <tr><td>Sepia</td><td>23g</td></tr>
            <tr><td>Skyr</td><td>16g</td></tr>
          </tbody>
        </table>

        <p>El atún en lata al natural es probablemente el alimento con mejor ratio proteína/calorías que existe: <strong>25g de proteína por cada 100 calorías</strong>.</p>

        <h2>Cómo saber cuánta proteína tiene tu plato real</h2>
        <p>Las tablas están bien para planificar, pero cuando cocinas un plato con varios ingredientes, calcular la proteína total se complica. ¿Cuánta proteína tiene tu guiso de lentejas con chorizo? ¿Y esa ensalada que preparaste con lo que había en la nevera?</p>

        <p>Apps como Wayo resuelven esto: haces una foto a tu plato terminado y la IA te dice los gramos de proteína, y el resto de macros, en 3 segundos. Especialmente útil para comida casera, platos combinados o cuando comes fuera y no puedes pesar ingredientes.</p>

        <p>Si tu objetivo es llegar a 150g de proteína al día, saber exactamente cuánto llevas después de cada comida te permite ajustar las siguientes. Sin adivinar.</p>

        <div class="cta-box">
          <h3>Todo en una sola app</h3>
          <p>No necesitas 5 apps diferentes para fitness, nutrición, rutinas y hábitos. Wayo lo integra todo.</p>
          <a href="https://wayoai.app/download" class="cta-button">Descargar Wayo gratis</a>
        </div>

        <h2>Preguntas frecuentes</h2>

        <div class="faq-section">
          <h4>¿Cuál es el alimento con más proteína del mundo?</h4>
          <p>La espirulina en polvo tiene un 57% de proteína, pero nadie come 150g de espirulina. En términos de ración real, la pechuga de pollo y el pavo lideran con 44-46g de proteína por ración de 150g.</p>

          <h4>¿La proteína del huevo está en la clara o en la yema?</h4>
          <p>Ambas, pero la clara tiene proporcionalmente más proteína y menos grasa. Un huevo entero tiene 7g de proteína: 3,6g en la clara y 2,7g en la yema. La yema aporta además grasas saludables y vitaminas, por lo que comer el huevo entero es la mejor opción salvo que estés en un déficit muy estricto.</p>

          <h4>¿Las legumbres son buena fuente de proteína?</h4>
          <p>Sí, pero son una fuente incompleta por sí solas porque les falta el aminoácido metionina. Combinándolas con cereales como arroz o pan en el mismo día obtienes todos los aminoácidos esenciales. No hace falta combinarlos en la misma comida: en el mismo día es suficiente.</p>

          <h4>¿Cuánta proteína tiene un filete de pollo del súper?</h4>
          <p>Una pechuga de pollo estándar del supermercado pesa entre 150-200g y tiene entre 46-60g de proteína. Es probablemente la fuente de proteína más accesible y económica que existe.</p>
        </div>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200",
    author: "Wayo Nutrition Team",
    date: "2026-04-11",
    category: "Nutrición",
    tags: ["proteína", "alimentos proteicos", "macros", "nutrición", "déficit calórico"],
    readTime: "12 min",
    metaDescription: "Tabla con 50 alimentos ricos en proteína y los gramos por ración real: carnes, pescados, huevos, lácteos, legumbres y opciones veganas.",
    keywords: [
      "alimentos ricos en proteína",
      "alimentos altos en proteína",
      "proteína por ración",
      "lista alimentos proteína",
      "comidas con proteína",
      "150g proteína al día",
      "proteína calorías"
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cuál es el alimento con más proteína del mundo?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "La espirulina en polvo tiene un 57% de proteína, pero en términos de ración real la pechuga de pollo y el pavo lideran con 44-46g de proteína por ración de 150g."
          }
        },
        {
          "@type": "Question",
          "name": "¿La proteína del huevo está en la clara o en la yema?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ambas partes tienen proteína. Un huevo entero aporta unos 7g: aproximadamente 3,6g en la clara y 2,7g en la yema."
          }
        },
        {
          "@type": "Question",
          "name": "¿Las legumbres son buena fuente de proteína?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí. Las legumbres aportan proteína y, combinadas con cereales en el mismo día, ayudan a completar el perfil de aminoácidos esenciales."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánta proteína tiene un filete de pollo del súper?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Una pechuga de pollo estándar suele pesar entre 150 y 200g y aporta aproximadamente entre 46 y 60g de proteína."
          }
        }
      ]
    }
  },
  {
    id: 165,
    slug: "cuantas-calorias-consumir-al-dia-calculadora",
    title: "¿Cuántas Calorías Debo Consumir al Día? Calculadora Según Peso y Objetivo (2026)",
    seoTitle: "¿Cuántas Calorías Debo Consumir al Día? Calculadora (2026)",
    h1: "¿Cuántas calorías debo consumir al día?",
    excerpt: "Calcula cuántas calorías necesitas consumir al día según tu peso, altura, edad, actividad y objetivo: perder grasa, mantener o ganar músculo.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">¿Cuántas calorías debo consumir al día? La respuesta depende de tu peso, altura, edad, sexo y nivel de actividad física. No existe un número universal porque cada cuerpo tiene necesidades diferentes.</p>

        <p>La respuesta rápida: un hombre adulto de 80 kg moderadamente activo necesita entre <strong>2.200 y 2.600 calorías al día</strong> para mantener su peso. Una mujer adulta de 65 kg con actividad moderada necesita entre <strong>1.800 y 2.100 calorías</strong>. Pero estos son promedios: tu cifra exacta depende de varios factores que vamos a calcular juntos.</p>

        <h2>Cómo calcular tus calorías diarias paso a paso</h2>
        <p>El método más fiable para calcular cuántas calorías necesitas es la fórmula de Harris-Benedict revisada, que calcula tu metabolismo basal, las calorías que tu cuerpo quema solo por existir, y después lo multiplica por tu nivel de actividad.</p>

        <h3>Paso 1: Calcula tu metabolismo basal (TMB)</h3>
        <div class="info-box">
          <p><strong>Para hombres:</strong><br>TMB = 88,36 + (13,4 × peso en kg) + (4,8 × altura en cm) − (5,7 × edad en años)</p>
          <p><strong>Para mujeres:</strong><br>TMB = 447,6 + (9,2 × peso en kg) + (3,1 × altura en cm) − (4,3 × edad en años)</p>
        </div>

        <h3>Paso 2: Multiplica por tu factor de actividad</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Nivel de actividad</th><th>Multiplicador</th></tr>
          </thead>
          <tbody>
            <tr><td>Sedentario (oficina, poco movimiento)</td><td>TMB × 1,2</td></tr>
            <tr><td>Ligeramente activo (ejercicio 1-3 días/semana)</td><td>TMB × 1,375</td></tr>
            <tr><td>Moderadamente activo (ejercicio 3-5 días/semana)</td><td>TMB × 1,55</td></tr>
            <tr><td>Muy activo (ejercicio 6-7 días/semana)</td><td>TMB × 1,725</td></tr>
            <tr><td>Extremadamente activo (atleta, trabajo físico intenso)</td><td>TMB × 1,9</td></tr>
          </tbody>
        </table>

        <h3>Ejemplo práctico</h3>
        <p>Hombre de 30 años, 80 kg, 178 cm, entrena 4 veces por semana:</p>
        <p><strong>TMB</strong> = 88,36 + (13,4 × 80) + (4,8 × 178) − (5,7 × 30) = 88,36 + 1.072 + 854,4 − 171 = <strong>1.843,76 kcal</strong></p>
        <p><strong>Calorías de mantenimiento</strong> = 1.843 × 1,55 = <strong>2.857 kcal/día</strong></p>
        <p>Este hombre necesita aproximadamente <strong>2.860 calorías al día</strong> para mantener su peso.</p>

        <h2>Tabla de calorías diarias según peso (hombres)</h2>
        <p>Calculado para hombre de 30 años, 175 cm, moderadamente activo (entrena 3-5 días/semana):</p>
        <table class="comparison-table">
          <thead>
            <tr><th>Peso</th><th>Mantenimiento</th><th>Perder grasa (−500 kcal)</th><th>Ganar músculo (+300 kcal)</th></tr>
          </thead>
          <tbody>
            <tr><td>60 kg</td><td>2.400 kcal</td><td>1.900 kcal</td><td>2.700 kcal</td></tr>
            <tr><td>65 kg</td><td>2.500 kcal</td><td>2.000 kcal</td><td>2.800 kcal</td></tr>
            <tr><td>70 kg</td><td>2.600 kcal</td><td>2.100 kcal</td><td>2.900 kcal</td></tr>
            <tr><td>75 kg</td><td>2.700 kcal</td><td>2.200 kcal</td><td>3.000 kcal</td></tr>
            <tr><td>80 kg</td><td>2.860 kcal</td><td>2.360 kcal</td><td>3.160 kcal</td></tr>
            <tr><td>85 kg</td><td>2.960 kcal</td><td>2.460 kcal</td><td>3.260 kcal</td></tr>
            <tr><td>90 kg</td><td>3.060 kcal</td><td>2.560 kcal</td><td>3.360 kcal</td></tr>
            <tr><td>95 kg</td><td>3.160 kcal</td><td>2.660 kcal</td><td>3.460 kcal</td></tr>
            <tr><td>100 kg</td><td>3.260 kcal</td><td>2.760 kcal</td><td>3.560 kcal</td></tr>
          </tbody>
        </table>

        <h2>Tabla de calorías diarias según peso (mujeres)</h2>
        <p>Calculado para mujer de 30 años, 165 cm, moderadamente activa:</p>
        <table class="comparison-table">
          <thead>
            <tr><th>Peso</th><th>Mantenimiento</th><th>Perder grasa (−400 kcal)</th><th>Ganar músculo (+250 kcal)</th></tr>
          </thead>
          <tbody>
            <tr><td>50 kg</td><td>1.750 kcal</td><td>1.350 kcal</td><td>2.000 kcal</td></tr>
            <tr><td>55 kg</td><td>1.820 kcal</td><td>1.420 kcal</td><td>2.070 kcal</td></tr>
            <tr><td>60 kg</td><td>1.890 kcal</td><td>1.490 kcal</td><td>2.140 kcal</td></tr>
            <tr><td>65 kg</td><td>1.960 kcal</td><td>1.560 kcal</td><td>2.210 kcal</td></tr>
            <tr><td>70 kg</td><td>2.030 kcal</td><td>1.630 kcal</td><td>2.280 kcal</td></tr>
            <tr><td>75 kg</td><td>2.100 kcal</td><td>1.700 kcal</td><td>2.350 kcal</td></tr>
            <tr><td>80 kg</td><td>2.170 kcal</td><td>1.770 kcal</td><td>2.420 kcal</td></tr>
            <tr><td>85 kg</td><td>2.240 kcal</td><td>1.840 kcal</td><td>2.490 kcal</td></tr>
          </tbody>
        </table>

        <h2>Cuántas calorías necesitas según tu objetivo</h2>
        <p><strong>Para perder grasa:</strong> resta entre 300 y 500 calorías a tu mantenimiento. Nunca bajes de 1.200 kcal (mujeres) o 1.500 kcal (hombres) sin supervisión profesional. Un déficit de 500 kcal/día equivale a perder aproximadamente 0,5 kg por semana.</p>
        <p><strong>Para mantener peso:</strong> come tus calorías de mantenimiento. Esto es lo que necesitas si estás satisfecho con tu composición corporal y solo quieres mantenerla.</p>
        <p><strong>Para ganar músculo:</strong> suma entre 200 y 400 calorías a tu mantenimiento. Más de eso no acelera la ganancia muscular: solo acumulas más grasa. Combínalo con entrenamiento de fuerza progresivo.</p>

        <h2>Calorías diarias hombre 80 kg: ejemplo completo</h2>
        <p>Es una de las consultas más frecuentes, así que vamos a desglosarlo con detalle.</p>
        <p>Un hombre de 80 kg necesita entre 2.200 y 3.100 calorías al día dependiendo de su actividad:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Actividad</th><th>Calorías/día</th></tr>
          </thead>
          <tbody>
            <tr><td>Sedentario (oficina, no entrena)</td><td>2.200 kcal</td></tr>
            <tr><td>Ligeramente activo (camina, entrena 1-2x/semana)</td><td>2.530 kcal</td></tr>
            <tr><td>Moderadamente activo (entrena 3-5x/semana)</td><td>2.860 kcal</td></tr>
            <tr><td>Muy activo (entrena 6-7x/semana, trabajo activo)</td><td>3.180 kcal</td></tr>
          </tbody>
        </table>

        <p>Si este hombre quiere perder grasa, debería comer entre <strong>2.200 y 2.400 kcal</strong>, dependiendo de su actividad, para crear un déficit saludable.</p>
        <p>Si quiere ganar músculo, debería comer entre <strong>2.900 y 3.200 kcal</strong> combinado con entrenamiento de fuerza y un aporte de proteína de al menos 1,6g por kg de peso corporal: 128g de proteína al día.</p>

        <h2>Los 3 errores más comunes al calcular tus calorías</h2>
        <h3>Error 1: Sobreestimar tu nivel de actividad</h3>
        <p>Ir al gimnasio 3 veces por semana pero pasar el resto del día sentado no es "muy activo". La mayoría de personas que entrenan 3-5 días son "moderadamente activas" como mucho. Elegir un multiplicador demasiado alto te da un número inflado y no verás resultados.</p>

        <h3>Error 2: No ajustar con el tiempo</h3>
        <p>Si empezaste pesando 90 kg y ahora pesas 80, tus calorías de mantenimiento han bajado. Tu cuerpo más pequeño necesita menos energía. Recalcula cada 4-6 semanas o cuando tu peso cambie más de 3 kg.</p>

        <h3>Error 3: Fiarse de estimaciones en vez de datos reales</h3>
        <p>Puedes calcular que necesitas 2.500 kcal, pero si no sabes cuánto estás comiendo realmente, el cálculo no sirve de nada. La diferencia entre "creo que como 2.000" y "como exactamente 2.350" puede ser la razón por la que no ves resultados.</p>

        <h2>Cómo saber cuántas calorías comes realmente</h2>
        <p>La forma más precisa de saber cuántas calorías consumes es registrar tus comidas durante al menos 7 días. El promedio semanal te da una imagen real de tu consumo, mucho más fiable que un solo día.</p>

        <p>Existen diferentes formas de hacerlo: desde apuntar en un cuaderno hasta usar una app. La ventaja de usar una app con reconocimiento por foto, como Wayo, es que reduces el registro a 3 segundos por comida: haces una foto, la IA reconoce los alimentos y te muestra las calorías y macros instantáneamente. Sin buscar ingredientes, sin pesar, sin dedicar 20 minutos por comida.</p>

        <p>Una vez que sabes cuánto comes realmente, puedes compararlo con tu número objetivo y ajustar. Si necesitas 2.500 y estás comiendo 2.900, ya sabes exactamente qué ajustar y cuánto.</p>

        <div class="cta-box">
          <h3>Calcula tu día con una foto</h3>
          <p>Escanea tus comidas con Wayo y mira calorías, proteína, carbohidratos y grasas en segundos.</p>
          <a href="https://wayoai.app/download" class="cta-button">Descargar Wayo gratis</a>
        </div>

        <h2>Preguntas frecuentes</h2>
        <div class="faq-section">
          <h4>¿1.500 calorías al día es muy poco?</h4>
          <p>Depende de quién seas. Para una mujer pequeña y sedentaria puede ser adecuado. Para un hombre activo de 80 kg es demasiado poco y puede causar pérdida de masa muscular, fatiga y ralentización metabólica. Lo importante es no bajar de tu TMB durante periodos prolongados.</p>

          <h4>¿Cuántas calorías debo comer para perder 1 kg por semana?</h4>
          <p>Para perder 1 kg por semana necesitas un déficit de aproximadamente 1.000 kcal diarias. Esto es agresivo y no se recomienda durante más de 4-6 semanas. Un déficit de 500 kcal, medio kg por semana, es más sostenible y preserva mejor la masa muscular.</p>

          <h4>¿Las calorías que quemo haciendo ejercicio cuentan?</h4>
          <p>Sí, pero no las añadas a tu ingesta. El factor de actividad de la fórmula ya incluye el ejercicio. Si comes extra "porque entrené" acabas anulando el déficit. Si usas un reloj de actividad, ten en cuenta que sobreestiman las calorías quemadas entre un 20% y un 40%.</p>

          <h4>¿Da igual cuándo como las calorías?</h4>
          <p>Para el peso total, lo que importa es el balance semanal, no la hora. Puedes cenar fuerte y desayunar ligero o al revés: mientras el total sea el correcto, el resultado será el mismo. Lo que sí puede variar es tu rendimiento deportivo si entrenas con el estómago vacío.</p>

          <h4>¿Cómo sé si estoy comiendo las calorías correctas?</h4>
          <p>La mejor forma es pesarte cada mañana durante 2 semanas y calcular la media semanal. Si tu media baja entre 0,3 y 0,5 kg por semana, estás en un buen déficit. Si no baja, ajusta 200 kcal menos. Si baja más de 1 kg/semana, estás en un déficit demasiado agresivo.</p>
        </div>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200",
    author: "Wayo Nutrition Team",
    date: "2026-04-11",
    category: "Nutrición",
    tags: ["calorías", "calculadora calorías", "déficit calórico", "mantenimiento", "ganar músculo"],
    readTime: "11 min",
    metaDescription: "Calcula cuántas calorías necesitas al día según tu peso, altura, edad y objetivo (perder grasa, mantener o ganar músculo). Con tabla por peso de 50 a 100 kg y fórmula Harris-Benedict actualizada.",
    keywords: [
      "cuántas calorías consumir al día",
      "cuántas calorías debo consumir al día",
      "calculadora calorías",
      "calorías diarias",
      "Harris-Benedict",
      "calorías para perder grasa",
      "calorías mantenimiento",
      "calorías ganar músculo"
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿1.500 calorías al día es muy poco?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Depende de la persona. Para una mujer pequeña y sedentaria puede ser adecuado, pero para un hombre activo de 80 kg suele ser demasiado poco y puede causar pérdida de masa muscular, fatiga y ralentización metabólica."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuántas calorías debo comer para perder 1 kg por semana?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Para perder 1 kg por semana necesitas un déficit aproximado de 1.000 kcal diarias. Es un enfoque agresivo y normalmente se recomienda un déficit de 500 kcal para perder alrededor de 0,5 kg por semana."
          }
        },
        {
          "@type": "Question",
          "name": "¿Las calorías que quemo haciendo ejercicio cuentan?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, pero el factor de actividad de la fórmula ya incluye el ejercicio. Añadir esas calorías de nuevo a tu ingesta puede anular el déficit."
          }
        },
        {
          "@type": "Question",
          "name": "¿Da igual cuándo como las calorías?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Para el peso total, lo más importante es el balance semanal de calorías. La hora puede influir en rendimiento, hambre o digestión, pero no cambia el balance energético total."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cómo sé si estoy comiendo las calorías correctas?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Pésate cada mañana durante 2 semanas y calcula la media semanal. Si la media baja entre 0,3 y 0,5 kg por semana, estás en un buen déficit. Si no baja, ajusta unas 200 kcal menos."
          }
        }
      ]
    }
  },
  {
    id: 166,
    slug: "deficit-calorico-guia-completa-2026",
    title: "Déficit Calórico: Qué Es, Cómo Calcularlo y Cuánto Necesitas para Perder Grasa (2026)",
    seoTitle: "Déficit Calórico: Qué Es y Cómo Calcular el Tuyo (2026)",
    h1: "Déficit calórico: qué es y cómo calcularlo para perder grasa",
    excerpt: "Aprende qué es el déficit calórico, cómo calcular el tuyo paso a paso y cuántas calorías reducir para perder grasa sin perder músculo.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">El déficit calórico es la diferencia entre las calorías que tu cuerpo necesita y las que realmente consumes. Si consumes menos de las que gastas, estás en déficit, y tu cuerpo usa la grasa almacenada como energía. Así es como pierdes grasa. No hay otro mecanismo.</p>

        <p>La respuesta rápida: para perder grasa de forma saludable necesitas un déficit de <strong>300 a 500 calorías diarias</strong>. Eso equivale a perder entre 0,3 y 0,5 kg por semana. Menos que eso y no verás resultados. Más que eso y arriesgas perder músculo junto con la grasa.</p>

        <h2>Qué es el déficit calórico exactamente</h2>
        <p>Tu cuerpo gasta energía constantemente: respirar, bombear sangre, regular la temperatura, digerir comida, moverte, pensar. La suma de toda esa energía es tu gasto calórico total diario (TDEE).</p>

        <p>Cuando comes exactamente lo que gastas, mantienes tu peso. Cuando comes más, subes. Cuando comes menos, bajas.</p>

        <p>El déficit calórico es simplemente comer menos de lo que gastas. Si tu TDEE es 2.500 kcal y comes 2.000, tienes un déficit de 500 kcal. Tu cuerpo busca esas 500 kcal faltantes en tus reservas de grasa.</p>

        <p>No es una dieta. No es un truco. Es física básica aplicada a tu cuerpo.</p>

        <h2>Cómo calcular tu déficit calórico paso a paso</h2>

        <h3>Paso 1: Calcula tu metabolismo basal (TMB)</h3>
        <p>Fórmula de Harris-Benedict:</p>
        <div class="info-box">
          <p><strong>Hombres:</strong> TMB = 88,36 + (13,4 × peso en kg) + (4,8 × altura en cm) − (5,7 × edad)</p>
          <p><strong>Mujeres:</strong> TMB = 447,6 + (9,2 × peso en kg) + (3,1 × altura en cm) − (4,3 × edad)</p>
        </div>

        <h3>Paso 2: Multiplica por tu actividad para obtener tu TDEE</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Nivel de actividad</th><th>Multiplicador</th></tr>
          </thead>
          <tbody>
            <tr><td>Sedentario (oficina, no entrenas)</td><td>× 1,2</td></tr>
            <tr><td>Ligeramente activo (entrenas 1-3 días)</td><td>× 1,375</td></tr>
            <tr><td>Moderadamente activo (entrenas 3-5 días)</td><td>× 1,55</td></tr>
            <tr><td>Muy activo (entrenas 6-7 días)</td><td>× 1,725</td></tr>
          </tbody>
        </table>

        <h3>Paso 3: Resta las calorías del déficit</h3>
        <table class="comparison-table">
          <thead>
            <tr><th>Objetivo</th><th>Déficit</th><th>Pérdida estimada/semana</th></tr>
          </thead>
          <tbody>
            <tr><td>Perder grasa suave</td><td>−300 kcal</td><td>0,3 kg/semana</td></tr>
            <tr><td>Perder grasa moderado</td><td>−500 kcal</td><td>0,5 kg/semana</td></tr>
            <tr><td>Perder grasa agresivo</td><td>−750 kcal</td><td>0,7 kg/semana</td></tr>
            <tr><td>Perder grasa muy agresivo</td><td>−1.000 kcal</td><td>1 kg/semana</td></tr>
          </tbody>
        </table>

        <p>Un déficit de 500 kcal es el punto ideal para la mayoría de personas: suficiente para ver resultados semanales, pero no tan agresivo como para perder músculo o pasar hambre constante.</p>

        <h2>Ejemplo completo por perfiles</h2>

        <h3>Hombre, 85 kg, 30 años, 180 cm, entrena 4 veces/semana</h3>
        <p>TMB = 88,36 + (13,4 × 85) + (4,8 × 180) − (5,7 × 30) = <strong>1.935 kcal</strong></p>
        <p>TDEE = 1.935 × 1,55 = <strong>2.999 kcal</strong></p>
        <p>Déficit de 500 kcal → comer <strong>2.500 kcal/día</strong> para perder 0,5 kg/semana.</p>

        <h3>Mujer, 70 kg, 28 años, 165 cm, entrena 3 veces/semana</h3>
        <p>TMB = 447,6 + (9,2 × 70) + (3,1 × 165) − (4,3 × 28) = <strong>1.478 kcal</strong></p>
        <p>TDEE = 1.478 × 1,55 = <strong>2.291 kcal</strong></p>
        <p>Déficit de 400 kcal → comer <strong>1.890 kcal/día</strong> para perder 0,4 kg/semana.</p>

        <h3>Hombre, 100 kg, 35 años, 175 cm, sedentario, quiere empezar</h3>
        <p>TMB = 88,36 + (13,4 × 100) + (4,8 × 175) − (5,7 × 35) = <strong>2.068 kcal</strong></p>
        <p>TDEE = 2.068 × 1,2 = <strong>2.482 kcal</strong></p>
        <p>Déficit de 500 kcal → comer <strong>1.980 kcal/día</strong>.</p>

        <h2>Tabla rápida de déficit calórico por peso</h2>
        <p>Calculado para hombres de 30 años, moderadamente activos:</p>
        <table class="comparison-table">
          <thead>
            <tr><th>Peso</th><th>TDEE</th><th>Déficit −500</th><th>Proteína mínima</th></tr>
          </thead>
          <tbody>
            <tr><td>70 kg</td><td>2.600 kcal</td><td>2.100 kcal</td><td>112-140g</td></tr>
            <tr><td>75 kg</td><td>2.730 kcal</td><td>2.230 kcal</td><td>120-150g</td></tr>
            <tr><td>80 kg</td><td>2.860 kcal</td><td>2.360 kcal</td><td>128-160g</td></tr>
            <tr><td>85 kg</td><td>3.000 kcal</td><td>2.500 kcal</td><td>136-170g</td></tr>
            <tr><td>90 kg</td><td>3.130 kcal</td><td>2.630 kcal</td><td>144-180g</td></tr>
            <tr><td>95 kg</td><td>3.260 kcal</td><td>2.760 kcal</td><td>152-190g</td></tr>
            <tr><td>100 kg</td><td>3.390 kcal</td><td>2.890 kcal</td><td>160-200g</td></tr>
          </tbody>
        </table>

        <h2>Déficit calórico sin perder músculo: las 4 reglas</h2>
        <p>Perder grasa es fácil. Perder grasa sin perder músculo requiere estrategia. Sigue estas 4 reglas:</p>

        <h3>Regla 1: Proteína alta</h3>
        <p>Come entre 1,6 y 2,2 gramos de proteína por kg de peso corporal. Si pesas 80 kg, necesitas entre 128 y 176 gramos de proteína al día. La proteína protege tu masa muscular durante el déficit y además te sacia más que los carbohidratos o las grasas.</p>

        <h3>Regla 2: Entrena fuerza</h3>
        <p>El estímulo de entrenamiento de fuerza le dice a tu cuerpo "necesito estos músculos, no los quemes". Sin entrenamiento de fuerza, tu cuerpo no tiene razón para preservar el músculo durante un déficit. Entrena al menos 3 veces por semana con pesos progresivos.</p>

        <h3>Regla 3: Déficit moderado</h3>
        <p>Un déficit superior a 750 kcal aumenta significativamente la pérdida de masa muscular, incluso con proteína alta y entrenamiento. Sé paciente. Mejor 0,5 kg por semana durante 3 meses que 1 kg por semana durante 6 semanas y después efecto rebote.</p>

        <h3>Regla 4: Mide tu progreso con la media semanal</h3>
        <p>Tu peso fluctúa entre 0,5 y 2 kg en un solo día por agua, comida en el estómago y retención. Si te pesas solo un día y ese día retenías líquidos, crees que no avanzas. Pésate cada mañana, calcula la media de la semana, y compara medias semanales. Eso sí refleja la tendencia real.</p>

        <h2>Los 5 errores más comunes con el déficit calórico</h2>

        <h3>Error 1: "Creo que como 1.800 pero como 2.400"</h3>
        <p>El error número uno. La mayoría de personas subestima lo que come entre un 20% y un 40%. Ese chorrito de aceite, ese snack a media tarde, ese trozo de pan mientras cocinas: todo suma. Si no registras lo que comes, estás adivinando. Y adivinar no funciona.</p>

        <h3>Error 2: Déficit demasiado agresivo</h3>
        <p>Comer 1.200 calorías cuando necesitas 2.500 genera un déficit de 1.300 kcal. Eso es insostenible. Pierdes músculo, tu metabolismo se ralentiza, tienes hambre extrema y acabas dándote un atracón el fin de semana que anula todo el déficit de la semana. Un déficit de 400-500 kcal es suficiente y sostenible.</p>

        <h3>Error 3: No incluir los fines de semana</h3>
        <p>Comes en déficit de lunes a viernes (−500 kcal × 5 = −2.500 kcal) y el fin de semana comes 1.000 kcal de más cada día (+2.000 kcal). Resultado semanal: −500 kcal en toda la semana. Eso es un déficit de 71 kcal al día. Prácticamente nada. Por eso la media semanal importa más que el día a día.</p>

        <h3>Error 4: Compensar ejercicio con comida</h3>
        <p>"Hoy entrené duro, me merezco comerme esto." Tu reloj dice que quemaste 600 kcal corriendo. En realidad fueron 350. Y te comes un extra de 500 kcal. Has anulado el déficit. No comas según lo que dice tu reloj que quemaste: come según tu plan.</p>

        <h3>Error 5: No ajustar con el tiempo</h3>
        <p>Empezaste con 90 kg y un TDEE de 3.000. Ahora pesas 80 kg: tu TDEE es 2.700. Si sigues comiendo 2.500, tu déficit pasó de 500 a 200 kcal. El progreso se frena. Recalcula cada 4-6 semanas.</p>

        <h2>Cuánto tiempo mantener el déficit calórico</h2>
        <p>No mantengas un déficit indefinidamente. La recomendación basada en evidencia es:</p>
        <ul>
          <li><strong>Fase de déficit:</strong> 8 a 16 semanas</li>
          <li><strong>Fase de mantenimiento:</strong> 4 a 8 semanas comiendo a tu TDEE nuevo</li>
          <li><strong>Repetir</strong> si necesitas perder más grasa</li>
        </ul>

        <p>Las fases de mantenimiento permiten que tu metabolismo se estabilice, tus hormonas se regulen y tu adherencia se mantenga. Intentar estar en déficit 6 meses seguidos acaba en fatiga metabólica y atracones.</p>

        <h2>Cómo saber si estás realmente en déficit</h2>
        <p>La única forma de saber si estás en déficit es medir dos cosas: lo que comes y lo que pesas.</p>

        <p>Si registras tus comidas durante 7-14 días y tu media semanal de peso baja entre 0,3 y 0,5 kg, estás en déficit. Si no baja, necesitas comer 200 kcal menos o moverte más. Así de simple.</p>

        <p>El problema para la mayoría de personas es registrar las comidas. Los métodos tradicionales (buscar cada ingrediente, pesar comida, apuntar en una tabla) consumen entre 15 y 30 minutos al día. Por eso la mayoría lo deja después de una semana.</p>

        <p>Apps con reconocimiento visual como Wayo reducen ese proceso a 3 segundos por comida: haces una foto y la IA te devuelve calorías y macros al instante. Cuando el registro no cuesta esfuerzo, lo mantienes en el tiempo. Y mantenerlo en el tiempo es lo que genera resultados.</p>

        <div class="cta-box">
          <h3>Comprueba tu déficit sin adivinar</h3>
          <p>Escanea tus comidas con Wayo y mira tus calorías y macros al instante. Menos cálculo manual, más constancia.</p>
          <a href="https://wayoai.app/download" class="cta-button">Descargar Wayo gratis</a>
        </div>

        <h2>Preguntas frecuentes</h2>
        <div class="faq-section">
          <h4>¿Puedo perder grasa sin contar calorías?</h4>
          <p>Sí, pero es mucho menos preciso. Puedes mejorar la calidad de lo que comes (más proteína, más verdura, menos procesados) y perder grasa sin contar. Pero si te estancas, necesitas datos. Sin saber cuánto comes, no puedes saber qué ajustar.</p>

          <h4>¿El déficit calórico ralentiza el metabolismo?</h4>
          <p>Un déficit moderado (300-500 kcal) tiene un efecto mínimo en tu metabolismo. Un déficit agresivo prolongado (más de 1.000 kcal durante meses) sí puede reducir tu tasa metabólica entre un 10-15%. Las fases de mantenimiento ayudan a contrarrestar esto.</p>

          <h4>¿Cuánto déficit calórico para perder 10 kg?</h4>
          <p>10 kg de grasa equivalen a unas 77.000 kcal. Con un déficit de 500 kcal/día, tardarías unas 22 semanas, unos 5,5 meses. Con un déficit de 750 kcal/día, unas 15 semanas, unos 3,7 meses. La segunda opción es más rápida pero más difícil de mantener y con mayor riesgo de perder músculo.</p>

          <h4>¿Es lo mismo déficit calórico que dieta?</h4>
          <p>No exactamente. Una "dieta" suele implicar reglas restrictivas: no comas X, solo come Y. El déficit calórico es un concepto energético: comes menos de lo que gastas, pero puedes comer lo que quieras mientras respetes el total. Puedes comer pizza, helado y chocolate y seguir en déficit si el total del día cuadra.</p>
        </div>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=1200",
    author: "Wayo Nutrition Team",
    date: "2026-04-11",
    category: "Nutrición",
    tags: ["déficit calórico", "perder grasa", "calorías", "proteína", "pérdida de peso"],
    readTime: "12 min",
    metaDescription: "Aprende qué es el déficit calórico, cómo calcular el tuyo paso a paso y cuántas calorías reducir para perder grasa sin perder músculo. Con fórmula, ejemplos prácticos por peso y los 5 errores que debes evitar.",
    keywords: [
      "déficit calórico",
      "deficit calorico guia completa",
      "cómo calcular déficit calórico",
      "cuántas calorías reducir",
      "perder grasa sin perder músculo",
      "TDEE",
      "Harris-Benedict"
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Puedo perder grasa sin contar calorías?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, pero es menos preciso. Mejorar la calidad de la dieta puede funcionar, pero si te estancas necesitas datos de ingesta y peso para saber qué ajustar."
          }
        },
        {
          "@type": "Question",
          "name": "¿El déficit calórico ralentiza el metabolismo?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Un déficit moderado de 300-500 kcal suele tener un efecto mínimo. Un déficit agresivo prolongado, especialmente superior a 1.000 kcal durante meses, sí puede reducir la tasa metabólica."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánto déficit calórico para perder 10 kg?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Con un déficit de 500 kcal al día, perder 10 kg puede llevar unas 22 semanas. Con 750 kcal al día, unas 15 semanas, aunque es más difícil de sostener."
          }
        },
        {
          "@type": "Question",
          "name": "¿Es lo mismo déficit calórico que dieta?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No exactamente. Una dieta suele ser un conjunto de reglas de alimentos; el déficit calórico es comer menos energía de la que gastas, independientemente del tipo de alimentos."
          }
        }
      ]
    }
  },
  {
    id: 167,
    slug: "cuanta-proteina-necesito-al-dia",
    title: "¿Cuánta Proteína Necesitas al Día? Tabla por Peso y Objetivo (Guía 2026)",
    seoTitle: "¿Cuánta Proteína al Día? Tabla por Peso y Objetivo",
    h1: "¿Cuánta proteína necesitas al día?",
    excerpt: "Descubre cuántos gramos de proteína necesitas al día según tu peso, si quieres perder grasa o ganar músculo. Con tabla de 50 a 100 kg, alimentos ricos en proteína y errores frecuentes.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">La cantidad de proteína que necesitas al día depende de tu peso corporal, tu nivel de actividad y tu objetivo. No es la misma para alguien sedentario que para alguien que entrena fuerza 5 días por semana.</p>

        <p>La respuesta rápida: si entrenas regularmente y quieres mantener o ganar masa muscular, necesitas entre <strong>1,6 y 2,2 gramos de proteína por kilogramo de peso corporal</strong> al día. Si pesas 75 kg, eso son entre 120 y 165 gramos de proteína diarios.</p>

        <h2>Cuánta proteína según tu objetivo</h2>

        <p>La ciencia ha establecido rangos claros según lo que buscas:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Objetivo</th><th>Proteína por kg de peso</th><th>Ejemplo (75 kg)</th></tr>
          </thead>
          <tbody>
            <tr><td>Sedentario (mantener salud general)</td><td>0,8 g/kg</td><td>60g al día</td></tr>
            <tr><td>Persona activa (deporte recreativo)</td><td>1,0-1,2 g/kg</td><td>75-90g al día</td></tr>
            <tr><td>Perder grasa (preservar músculo)</td><td>1,6-2,2 g/kg</td><td>120-165g al día</td></tr>
            <tr><td>Ganar músculo (volumen)</td><td>1,6-2,2 g/kg</td><td>120-165g al día</td></tr>
            <tr><td>Atleta de alto rendimiento</td><td>2,0-2,5 g/kg</td><td>150-188g al día</td></tr>
          </tbody>
        </table>

        <p><strong>Dato importante:</strong> el rango para perder grasa y para ganar músculo es prácticamente el mismo (1,6-2,2 g/kg). La proteína es crucial en ambos escenarios. Cuando pierdes grasa, la proteína alta evita que tu cuerpo queme músculo como energía. Cuando ganas músculo, la proteína proporciona los aminoácidos necesarios para construir tejido nuevo.</p>

        <h2>Tabla de proteína diaria por peso corporal</h2>

        <p><strong>Para personas que entrenan (1,6-2,2 g/kg):</strong></p>

        <table class="comparison-table">
          <thead>
            <tr><th>Tu peso</th><th>Proteína mínima (1,6 g/kg)</th><th>Proteína óptima (2,0 g/kg)</th><th>Proteína máxima (2,2 g/kg)</th></tr>
          </thead>
          <tbody>
            <tr><td>50 kg</td><td>80g</td><td>100g</td><td>110g</td></tr>
            <tr><td>55 kg</td><td>88g</td><td>110g</td><td>121g</td></tr>
            <tr><td>60 kg</td><td>96g</td><td>120g</td><td>132g</td></tr>
            <tr><td>65 kg</td><td>104g</td><td>130g</td><td>143g</td></tr>
            <tr><td>70 kg</td><td>112g</td><td>140g</td><td>154g</td></tr>
            <tr><td>75 kg</td><td>120g</td><td>150g</td><td>165g</td></tr>
            <tr><td>80 kg</td><td>128g</td><td>160g</td><td>176g</td></tr>
            <tr><td>85 kg</td><td>136g</td><td>170g</td><td>187g</td></tr>
            <tr><td>90 kg</td><td>144g</td><td>180g</td><td>198g</td></tr>
            <tr><td>95 kg</td><td>152g</td><td>190g</td><td>209g</td></tr>
            <tr><td>100 kg</td><td>160g</td><td>200g</td><td>220g</td></tr>
          </tbody>
        </table>

        <p>Si estás empezando, apunta al mínimo (1,6 g/kg). Si ya tienes experiencia entrenando y quieres optimizar resultados, apunta a 2,0 g/kg. Superar los 2,2 g/kg no aporta beneficios adicionales según la evidencia científica actual.</p>

        <h2>Alimentos ricos en proteína: cuánto aporta cada uno</h2>

        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Porción</th><th>Proteína</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td>Pechuga de pollo</td><td>150g</td><td>46g</td><td>248 kcal</td></tr>
            <tr><td>Salmón</td><td>150g</td><td>34g</td><td>312 kcal</td></tr>
            <tr><td>Atún en lata (al natural)</td><td>1 lata (80g)</td><td>24g</td><td>96 kcal</td></tr>
            <tr><td>Huevos</td><td>2 unidades</td><td>14g</td><td>156 kcal</td></tr>
            <tr><td>Yogur griego natural</td><td>200g</td><td>20g</td><td>130 kcal</td></tr>
            <tr><td>Lentejas cocidas</td><td>200g</td><td>18g</td><td>230 kcal</td></tr>
            <tr><td>Ternera magra</td><td>150g</td><td>39g</td><td>225 kcal</td></tr>
            <tr><td>Tofu firme</td><td>150g</td><td>18g</td><td>180 kcal</td></tr>
            <tr><td>Queso cottage</td><td>200g</td><td>24g</td><td>196 kcal</td></tr>
            <tr><td>Garbanzos cocidos</td><td>200g</td><td>16g</td><td>246 kcal</td></tr>
            <tr><td>Pavo</td><td>150g</td><td>44g</td><td>210 kcal</td></tr>
            <tr><td>Whey protein (1 scoop)</td><td>30g</td><td>24g</td><td>120 kcal</td></tr>
          </tbody>
        </table>

        <h2>Ejemplo de un día con 150g de proteína</h2>

        <p>Para alguien que necesita 150g de proteína al día, así podría distribuirse:</p>

        <ul>
          <li><strong>Desayuno:</strong> 2 huevos + yogur griego (200g) = 34g proteína</li>
          <li><strong>Media mañana:</strong> Atún en lata + tostada integral = 26g proteína</li>
          <li><strong>Almuerzo:</strong> Pechuga de pollo (150g) + arroz + verduras = 46g proteína</li>
          <li><strong>Merienda:</strong> Batido de whey protein = 24g proteína</li>
          <li><strong>Cena:</strong> Salmón (150g) + ensalada + patata = 34g proteína</li>
        </ul>

        <p><strong>Total: 164g de proteína</strong></p>

        <p>No hace falta comer solo pollo y atún. Con variedad de fuentes proteicas llegas sin problema a tu objetivo.</p>

        <h2>Los 5 errores más comunes con la proteína</h2>

        <h3>Error 1: Concentrar toda la proteína en una comida</h3>
        <p>Tu cuerpo no puede utilizar eficientemente más de 40-50g de proteína de una sola vez para síntesis muscular. Es mejor repartirla en 3-5 comidas a lo largo del día (25-40g por comida).</p>

        <h3>Error 2: Creer que "como suficiente proteína" sin medirlo</h3>
        <p>Cuando la gente estima su consumo de proteína, suele sobreestimarlo en un 30-40%. Muchas personas creen comer 120g y en realidad comen 70-80g. La única forma de saberlo es medir durante al menos una semana.</p>

        <h3>Error 3: Olvidar la proteína en el desayuno</h3>
        <p>El desayuno típico español (café con tostada, galletas, cereales) tiene entre 5 y 10g de proteína. Si tu objetivo son 150g al día, empezar el día con solo 5g te obliga a compensar demasiado en las comidas siguientes. Añade huevos, yogur griego o proteína en polvo al desayuno.</p>

        <h3>Error 4: Pensar que la proteína vegetal no cuenta</h3>
        <p>Las proteínas vegetales (legumbres, tofu, tempeh, seitán) son perfectamente válidas para ganar músculo. La única diferencia es que necesitas combinar diferentes fuentes vegetales para obtener todos los aminoácidos esenciales. Pero la proteína es proteína — no importa si viene de pollo o de lentejas.</p>

        <h3>Error 5: Creer que demasiada proteína es peligrosa para los riñones</h3>
        <p>Para personas con riñones sanos, ingestas de hasta 2,5 g/kg de peso corporal no causan daño renal. Los estudios son consistentes en esto. Si tienes enfermedad renal preexistente, consulta con tu médico, pero para la población general no es un problema.</p>

        <h2>Cómo saber cuánta proteína estás comiendo realmente</h2>

        <p>El mayor problema con la proteína no es saber cuánta necesitas — es saber cuánta estás comiendo. La mayoría de personas no tiene ni idea de los gramos de proteína que consume al día.</p>

        <p>Puedes calcularlo manualmente sumando las etiquetas de cada alimento, pero con comida casera o platos cocinados se complica rápido. Apps con reconocimiento visual como Wayo te permiten escanear tu plato con una foto y ver los macros instantáneamente — incluyendo los gramos de proteína. En 3 segundos sabes si tu almuerzo tiene 15g o 45g de proteína, y puedes ajustar la cena en consecuencia.</p>

        <p>Registrar tu proteína durante 7 días te da una imagen clara de tu consumo real. La mayoría de personas se sorprende al ver que come mucha menos proteína de la que creía.</p>

        <h2>Preguntas frecuentes sobre proteína</h2>

        <h3>¿Se puede comer demasiada proteína?</h3>
        <p>Técnicamente sí, pero es muy difícil pasarse con comida real. Consumir más de 2,5 g/kg no aporta beneficios adicionales para la masa muscular — tu cuerpo simplemente usa el exceso como energía. No es dañino, pero es innecesario.</p>

        <h3>¿Es necesario tomar proteína en polvo?</h3>
        <p>No es necesario. La proteína en polvo es un suplemento de conveniencia, no un requisito. Si llegas a tu objetivo con comida real, perfecto. Si te cuesta llegar o necesitas algo rápido post-entreno, un batido de whey es una solución práctica y económica.</p>

        <h3>¿Cuánta proteína se puede absorber por comida?</h3>
        <p>Tu cuerpo absorbe toda la proteína que comes — no "desperdicia" nada. Lo que tiene un tope es la síntesis de proteína muscular por comida, que se maximiza con 25-40g dependiendo de tu peso. Por eso repartir en 3-5 comidas es más eficiente que comer 100g de golpe.</p>

        <h3>¿La proteína engorda?</h3>
        <p>La proteína tiene 4 calorías por gramo, igual que los carbohidratos. Lo que engorda es un exceso calórico total, no la proteína en sí. De hecho, la proteína es el macronutriente más saciante y tiene el mayor efecto térmico (tu cuerpo gasta más energía al digerirla). Aumentar la proteína y reducir carbohidratos o grasas suele ayudar a perder grasa, no a ganarla.</p>
      </div>
    `,
    date: "2026-04-11",
    category: "Nutrición",
    tags: ["proteína", "macros", "nutrición", "ganar músculo", "perder grasa"],
    readTime: "10 min",
    author: "Wayo Team",
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200",
    metaDescription: "Descubre cuántos gramos de proteína necesitas al día según tu peso, si quieres perder grasa o ganar músculo. Con tabla de 50 a 100 kg, alimentos ricos en proteína y errores frecuentes.",
    keywords: [
      "cuánta proteína necesito",
      "proteína por día",
      "gramos de proteína al día",
      "proteína por peso corporal",
      "tabla proteína",
      "alimentos proteína",
      "perder grasa proteína",
      "ganar músculo proteína"
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cuánta proteína necesito si peso 75 kg?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Si entrenas regularmente, necesitas entre 120 y 165 gramos de proteína al día (1,6 a 2,2 g/kg). Si eres sedentario, con 60 gramos al día es suficiente."
          }
        },
        {
          "@type": "Question",
          "name": "¿Se puede comer demasiada proteína?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Consumir más de 2,5 g/kg de peso corporal no aporta beneficios adicionales para la masa muscular. No es dañino, pero es innecesario."
          }
        },
        {
          "@type": "Question",
          "name": "¿La proteína vegetal es tan buena como la de carne?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, perfectamente válida para ganar músculo. La única diferencia es que necesitas combinar diferentes fuentes vegetales para obtener todos los aminoácidos esenciales."
          }
        },
        {
          "@type": "Question",
          "name": "¿Demasiada proteína daña los riñones?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, para personas con riñones sanos. Ingestas de hasta 2,5 g/kg no causan daño renal según la evidencia científica."
          }
        },
        {
          "@type": "Question",
          "name": "¿La proteína en polvo es necesaria?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, es un suplemento de conveniencia. Si llegas a tu objetivo con comida real, es suficiente. Si necesitas algo rápido, es una solución práctica."
          }
        }
      ]
    }
  }
  // id 168 menu-semanal-perder-grasa-calorias-macros deleted — duplicate of blogPostsExtended.js
];
